module.exports = __webpack_public_path__ + "media/images/cert-background-5-dee0c4d86f33c4c6f83f7374464d021e.jpg";